<!-- =========================================================================================
    File Name: VxList.vue
    Description: list Component
    Component Name: VxList
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

 <div v-if="reset" style="z-index:99990; width:100%; height:100%; position:fixed; background-color: rgba(0,0,0,0.5); top:0; left:0">
  <div  :style="videoSetting" style="margin:auto; position:absolute; left:0; right:0; top:0; bottom:0; z-index:1 ;background-color: #F8F8F8">
    <iframe :style="videoSetting" :src="reset" frameborder="0" allowfullscreen></iframe>
    <i  @click="popupActive = false" class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null" style="position:absolute; top:0 right:0; z-index:2; margin-left:-40px">close</i>
  </div>
</div>
</template>

<script>
import {PLAY_CAMERA,CAMERA_REPORT_MUTATION} from '@/graphql'
export default {
  name: 'video-view',
    data () {
    return {
      popupActive:false,  
      IframeSrc:null,
      video_setting:{width:'640', height:'360'},
      videoSetting:{width:'640px', height:'360px'},
    }
    },
  props: {
    setting: {
      type: Array,
      required: false
    },
    camera: {
      type: Object,
      default:{}
    },
    active: {
      type: Boolean,
      required: true
    },
  },
  watch:{
     popupActive(val){
       if(!val){
          this.$emit('closeVideView')
          this.initValues()
       }
     },
      active(val){
        if(val){
           this.PlayCamera(this.camera.id,this.camera.code,this.setting,this.camera.location)
        }
      },
      windowWidth(val){
      if(val < this.video_setting.width){
            const calc = val * 0.95
            this.videoSetting.width=calc+'px'
            const height = (calc / this.video_setting.width) * this.video_setting.height
            this.videoSetting.height = height+'px'
            console.log(this.videoSetting.height)
      }
      else{
          this.videoSetting.width=this.video_setting.width+'px'
          this.videoSetting.height=this.video_setting.height+'px'
      }  
    }
  },
  computed: {
       windowWidth (){ 
        return this.$store.state.windowWidth 
       },
     reset () {
      if (this.popupActive) {
        return this.IframeSrc
      }
      if (!this.popupActive) {
         return this.IframeSrc = null
      }
     }
  },
  methods:{
      checkwindow(val){
      if(val < this.video_setting.width){
            const calc = val * 0.95
            this.videoSetting.width=calc+'px'
            const height = (calc / this.video_setting.width) * this.video_setting.height  
            this.videoSetting.height = height+'px'
            console.log(this.videoSetting.height)
      }
      else{
          this.videoSetting.width=this.video_setting.width+'px'
          this.videoSetting.height=this.video_setting.height+'px'
      }  
    }, 
      PlayCamera(id,code,settings,location) {
      settings.forEach(setting => {
        if(setting.key==='video_height'){
          if(setting.value){
            this.videoSetting.height=setting.value+'px'
            this.video_setting.height=setting.value
           }
        }
         if(setting.key==='video_width'){
            if(setting.value){
              this.videoSetting.width=setting.value+'px'
              this.video_setting.width=setting.value
            }
        }
      });        
      this.checkwindow(this.$store.state.windowWidth)
      this.$apollo
        .mutate({
          mutation: PLAY_CAMERA,
          variables: {
            id:id,
            code:code,
            location:location
          }
        })
        .then(response => {
          if (response) {
            if(response.data.playCamera.status==="Success"){
              this.IframeSrc = response.data.playCamera.embed_code
              this.popupActive = true
            }
            else{
                this.$vs.notify({
                title: 'Camera',
                text:   response.data.playCamera.message,
                color:  'danger',
                position: 'top-right'
              })
              this.$emit('closeVideView')
              this.initValues()
            }
          }
        }).catch(error => {
           this.$vs.notify({
                title: 'Camera',
                text:   'This camera is not configured correctly.',
                color:  'danger',
                position: 'top-right'
              })
        })
    },
    initValues(){
      this.popupActive=false  
      this.IframeSrc=null
      this.video_setting={width:'640', height:'360'}
      this.videoSetting={width:'640px', height:'360px'}
    },
      createCameraWatchTimeReport () {
      if(this.popupActive && this.camera.id){
      this.$apollo
        .mutate({
          mutation: CAMERA_REPORT_MUTATION,
          variables: {
            camera_id: this.camera.id

          }
        })
        .then(response => {
          if (response.data.createCameraWatchTimeReport.status == 'SUCCESS') {

            console.log('done')

          }
        }).catch(error => {

        })
      }  
      
    },
  },
  created(){
     this.interval = setInterval(() => this.createCameraWatchTimeReport(), 60000)
  }
}
</script>


